// pages/CategoryPage.tsx
import { useParams } from 'react-router-dom';
import { useEffect, useState } from 'react';
import axios from 'axios';
import { Link } from 'react-router-dom';

interface Item {
  id: number;
  title: string;
  img: string;
  desc: string;
  date: string;
}

const CategoryPage = () => {
  const api = process.env.REACT_APP_API_URL as string;
  const { slug } = useParams<{ slug: string }>();
  const [items, setItems] = useState<Item[]>([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    if (slug) {
      axios
        .get(`${api}/auth/news/category/${slug}`)
        .then((res) => {
          setItems(res.data);
          setLoading(false);
        })
        .catch((err) => {
          console.error(err);
          setItems([]);
          setLoading(false);
        });
    }
  }, [slug]);

  if (loading) {
    return <div className="p-8 text-center text-gray-500 text-lg">Loading...</div>;
  }

  return (
    <div className="p-4 md:p-8">
      <h1 className="text-2xl font-bold capitalize mb-6 border-b pb-2">{slug} Category</h1>

      {items.length === 0 ? (
        <p className="text-center text-gray-500">No items found in this category.</p>
      ) : (
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6">
          {items.map((item) => (
            <div key={item.id} className="bg-white rounded-lg overflow-hidden shadow hover:shadow-lg transition-all duration-300">
              <img
                src={`${api}/${item.img}`}
                alt={item.title}
                className="w-full h-48 object-cover"
              />
              <div className="p-4 flex flex-col  h-full">
                <div>
                  <h2 className="text-lg font-semibold text-gray-800 mb-2">{item.title}</h2>
                  <p className="text-sm text-gray-600 line-clamp-3 mb-4">{item.desc}</p>
                </div>
                <div className="mt-1">
                  <p className="text-xs text-gray-400 mb-2">{new Date(item.date).toLocaleDateString()}</p>
                  <Link
                    to={`/news/${item.id}`}
                    className="inline-block text-sm text-primary hover:underline font-medium"
                  >
                    View More →
                  </Link>
                </div>
              </div>
            </div>
          ))}
        </div>
      )}
    </div>
  );
};

export default CategoryPage;
